<template>
  <b-card
    class="sa-card sa-card-border"
    :header="titolo"
    header-tag="header"
    footer-tag="footer"
    title=""
  >
    <b-row no-gutters>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Regione</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          v-model="localData.regione"
          value-field="codiceIstat"
          text-field="regione"
          :disabled="isView"
          :options="regioneOptions"
         @change="onChangeRegione"
          required
        >
           <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
      </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Provincia</label>
        <!-- @change="onChangeProvincia" -->
        <b-form-select
          id="inline-form-custom-select-pref"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          v-model="localData.provincia"
          value-field="sigla"
          :disabled="isView"
          text-field="provincia"
          :options="provinciaOptions"
           @change="onChangeProvincia"
          required
        >
           <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
      </b-form-select>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">Comune</label>
        <b-form-select
          id="inline-form-custom-select-pref"
          class="mb-2 mr-sm-2 mb-sm-0"
          :value="null"
          v-model="localData.comune"
          :disabled="isView"
          value-field="codiceIstat"
          text-field="comune"
          :options="comuneOptions"
          @change="onChangeComune"
          required
        >
           <template #first>
              <b-form-select-option :value="null" disabled
                >- Seleziona -</b-form-select-option
              >
            </template>
      </b-form-select>
      </b-col>
      <b-col v-if="showCap" cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <label class="sa-label-data">CAP</label>
        <b-form-input :disabled="blockCap || isView" v-model="localData.cap"></b-form-input>
      </b-col>
      <b-col v-if="showIndirizzo" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <label class="sa-label-data">Indirizzo</label>
        <b-form-input @input="emitChange()" :disabled="isView" v-model="localData.indirizzo"></b-form-input>
      </b-col>
      <b-col cols="12">
        Result 
        {{ localData }}
      </b-col>
       <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="showAsl">
        <b-card
          class="sa-card sa-card-border"
          :header="showAslTitle"
          header-tag="header"
          footer-tag="footer"
          title=""
        >
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="12" xl="6">
              <label class="sa-label-data">Codice A.S.L.</label>
              <b-form-input
                v-model="localData.aslCodice"
                :disabled="isView || blockAsl"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">A.S.L.</label>
              <b-form-input
                v-model="localData.aslDenominazione"
                :disabled="isView || blockAsl"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Ambito</label>
              <b-form-input
                v-model="localData.aslAmbito"
                :disabled="isView"
              ></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Distretto</label>
              <b-form-input
                v-model="localData.aslDistretto"
                :disabled="isView"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
export default {
  props: {
    titolo: {
      type: String,
      required: true,
      default: () => {
        return "Titolo";
      },
    },
    showIndirizzo: {
      type: Boolean,
      required: false,
      default: () => {
        return true;
      },
    },
    showCap: {
      type: Boolean,
      default: () => {
        return true;
      },
    },
    showAsl:{
      type: Boolean,
      default: () => {
        return false;
      },
    },
    showAslTitle:{
      type: String,
      required: false,
      default: () =>{ return "Asl Riferimento"}
    },
    isView: {
      type: Boolean,
      required: false,
      default: () => {
        return false;
      },
    },
    regione:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    provincia:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    comune:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    indirizzo:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    cap:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    aslAmbito:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    aslCodice:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    aslDenominazione:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
    aslDistretto:{
      type: String,
      required: false,
      default: () =>{ return null}
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      linkRegioni:"/regioni",
      linkProvince: "/province",
      linkComune: "/comuni/provincia",
      linkAslResouce: "/asl/comune",
      regioneOptions: [],
      provinciaOptions: [],
      comuneOptions: [],
      blockCap:false,
      blockAsl:false,
      localData: {    
        regione: null,
        provincia: null,
        comune: null,
        cap: null,
        indirizzo: null,
        aslCodice:null,
        aslDenominazione:null,
        aslAmbito:null,
        aslDistretto:null
      }
    };
  },
  mounted() {
    console.log("mounted");
    let me = this;
    if(me.regione != null){
      me.localData.regione = me.regione;
    }
    if(me.provincia != null){
      me.localData.provincia = me.provincia;
    }
    if(me.comune != null){
      me.localData.comune = me.comune;
    }
    if(me.showIndirizzo){
      if(me.indirizzo != null){
      me.localData.indirizzo = me.indirizzo;
      }
    }
    if(me.showCap){
      if(me.cap != null){
      me.localData.cap = me.cap;
      }
    }


    me.loadRegioni();
  },
  methods: {
    resetAsl(){
      let me = this;
      me.localData.aslAmbito = null;
      me.localData.aslCodice = null;
      me.localData.aslDistretto = null;
      me.localData.aslDenominazione = null;
      me.emitChange();
    },

    onChangeRegione(regione) {
      let me = this;
      me.provinciaOptions = [];
      me.localData.provincia = null;
      me.localData.comune = null;
      me.localData.cap= null;
      me.blockCap = false;
      me.blockAsl = false;
      me.resetAsl();
      me.loadProvince(regione);
      me.emitChange();
    },
    onChangeProvincia(provincia){
         let me = this;
           me.comuneOptions = [];
           me.localData.comune = null;
           me.localData.cap= null;
           me.blockCap = false;
           me.resetAsl();        
           me.emitChange();
           me.loadComune(provincia);
   
    },
    onChangeComune(value) {
      let me = this;
      let comuneSelezionato = me.comuneOptions.filter(x=> x.primaryKey === value)
      if(comuneSelezionato.length == 1){
        let comune = comuneSelezionato[0];
        if(comune.cap){
          me.localData.cap = comune.cap;
          me.blockCap = true;
          me.emitChange();
        }

      }else{
        console.log("errore recupero comune..");
      }
       me.resetAsl();
       me.loadAsl(value);
       me.emitChange();
    },
    loadRegioni(){      
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkRegioni;
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((regione) => {
            me.regioneOptions.push(regione);
          });
        })
        .catch((error) => {
          console.log(
              error
          );
        });
    },
    loadProvince(regione) {
      let me = this;
      me.filtro = { regione: regione };
      let link = process.env.VUE_APP_PATH_API + me.linkProvince;
      axios.get(link, { params: me.filtro }).then((response) => {
        response.data.data.forEach((provincia) => {
              me.provinciaOptions.push(provincia);
        });
      });
    },
    loadComune(sigla) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
      axios.get(link).then((response) => {
        me.comuneOptions = [];
        me.comuneOptions = response.data.data;
      });
    },

    loadAsl(codiceIstat) {
      let me = this;

      let link = process.env.VUE_APP_PATH_API + me.linkAslResouce;
      let params = { istatComune: codiceIstat };
      if (codiceIstat) {
        axios
          .get(link, { params: params })
          .then((response) => {
            if (response.data.data !== null) {
                  me.localData.aslCodice =response.data.data.codiceRegione + response.data.data.codiceAzienda;
                  me.localData.aslDenominazione = response.data.data.denominazione;
                  me.blockAsl = true;
              me.emitChange();
            }else{
              me.blockAsl = false;
            }
          })
          .catch((error) => {
            console.log(" errore: " + error.response.status);
          });
      }
    },
    
    emitChange(){
      let me= this;
      me.$emit("updateJsonData",{...me.localData});
    },


  },
  watch:{
    'regione':function (params) {
      if(params){
        let me = this;
        me.localData.regione = params;
        me.localData.provincia = null;
        me.localData.comune = null;
        me.localData.cap = null;
        me.resetAsl()
        me.loadProvince(params);
      }
    },
    'provincia':function (params) {
      if(params){
        let me = this;
        me.localData.provincia = params;
        me.localData.comune = null;
        me.localData.cap = null;
        me.resetAsl()
        me.loadComune(params);
      }
    },
    'comune':function (params) {
      if(params){
        let me = this;
        me.localData.comune = params;
        me.resetAsl()
        me.loadAsl(params);
      }
    },
    'cap':function (params) {
      if(params){
        let me = this;
        me.localData.cap = params;
      }
    },
    'indirizzo':function (params) {
      if(params){
        let me = this;
        me.localData.indirizzo = params;
      }
    },
    'aslAmbito':function (params) {
        if(params){
        let me = this;
        me.localData.aslAmbito = params;
      }
    },
    'aslDenominazione':function (params) {
        if(params){
        let me = this;
        me.localData.aslDenominazione = params;
      }
    },
    'aslCodice':function (params) {
        if(params){
        let me = this;
        me.localData.aslCodice = params;
      }
    },
    'aslDistretto':function (params) {
        if(params){
        let me = this;
        me.localData.aslDistretto = params;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
